<template>
  <section class="create-merchant">
    <div class="coming-soon">
      <img
        src="~@/assets/img/smiling.svg"
        alt="Coming Soon">
      <h3>Coming Soon</h3>
    </div>
  </section>
  <!--<div>
    <CreateMerchantStep1
      v-if="stepOne"
      :whatsappp="whatsapp"
      :facebookp="facebook"
      @goNext="getDataFromStepOne"/>
    <CreateMerchantStep2
      v-if="stepTwo"
      :logop="logo"
      :business-namep="businessName"
      :domain-namep="domainName"
      @goBack="stepOneToStepTwo"
      @goNext="getDataFromStepTwo"/>
    <CreateMerchantStep3
      v-if="stepThree"
      :lbnp="legalBusinessName"
      :addressp="address"
      :creation-error="creationError"
      @goBack="stepTwoToStepThree"
      @createAccount="createMerchantMethod"/>
  </div>-->
</template>

<script>
import '@/assets/css/modules/_create-merchant.scss';

// import CreateMerchantStep1 from './CreateMerchantStep1';
// import CreateMerchantStep2 from './CreateMerchantStep2';
// import CreateMerchantStep3 from './CreateMerchantStep3';

export default {
  name: 'CreateMerchant',
  // components: {
  //   CreateMerchantStep1,
  //   CreateMerchantStep2,
  //   CreateMerchantStep3,
  // },
  // data() {
  //   return {
  //     stepOne: true,
  //     stepTwo: false,
  //     stepThree: false,
  //     logo: '',
  //     businessName: '',
  //     domainName: '',
  //     whatsapp: {},
  //     facebook: {},
  //     legalBusinessName: '',
  //     address: {
  //       line: '',
  //       city: '',
  //       postalCode: '',
  //       state: '',
  //       country: '',
  //     },
  //     creationError: {},
  //   };
  // },
  // methods: {
  //   stepOneToStepTwo() {
  //     this.stepOne = !this.stepOne;
  //     this.stepTwo = !this.stepTwo;
  //   },
  //   stepTwoToStepThree() {
  //     this.stepTwo = !this.stepTwo;
  //     this.stepThree = !this.stepThree;
  //   },
  //   getDataFromStepOne(payload) {
  //     this.whatsapp = payload.whatsapp;
  //     this.facebook = payload.facebook;
  //     this.stepOneToStepTwo();
  //   },
  //   getDataFromStepTwo(payload) {
  //     this.logo = payload.logo;
  //     this.businessName = payload.businessName;
  //     this.domainName = payload.domainName;
  //     this.stepTwoToStepThree();
  //   },
  //   createMerchantMethod(payload) {
  //     this.creationError = {};
  //     this.legalBusinessName = payload.legalBusinessName;
  //     this.address = payload.address;
  //
  //     const merchantData = {
  //       name: this.businessName,
  //       legal_merchant_name: this.legalBusinessName,
  //       legal_entity_type: 'string',
  //       homepage: '',
  //       logo: '',
  //       plan: 'basic',
  //       subdomain: this.domainName,
  //       address: this.address,
  //       social_platforms: {
  //         facebook: this.facebook,
  //         whatsapp: this.whatsapp,
  //       },
  //     };
  //     this.$api('POST', 'merchants', merchantData)
  //       .then((response) => {
  //         if (response.status === 200) {
  //           this.$router.push({
  //             name: 'Merchant',
  //             params: {
  //               merchant_id: response.data.id,
  //             },
  //           });
  //         }
  //       })
  //       .catch((error) => {
  //         this.creationError = error.response;
  //       });
  //   },
  // },
};
</script>
